import { render, staticRenderFns } from "./area.vue?vue&type=template&id=5bd16d01&scoped=true"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd16d01",
  null
  
)

export default component.exports